import React from 'react';
import StageWithText from 'commonComponents/Stages/StageWithText/StageWithText';
import Services from './Services/Services';
import styles from '../pages.module.scss';

const ServicesPage = ({ banner, content }) => {
  return (
    <div className={ styles.Page }>
      <StageWithText { ...banner } pageName='servicesOverview' />
      <Services { ...content } />
    </div>
  );
};
 
export default ServicesPage;
